/* 
 * 
 * 
 * 
 * 								L I B   N A M E S   S H A R E D
 * 
 * 
 * 
 */

export const lib_names_shared = {
	endpoints: {
		media_storage: 'https://media.nearby.coffee/',
		qrs_generator: 'https://api.qrserver.com/v1/create-qr-code/?size=1000x1000&data=',
		server_nearby: 'https://server.linktomenu.it/',
	//	server_nearby: 'http://localhost:3000/',
		sharing___view: 'https://view.linktomenu.it/',
		sharing___qr: 'https://open.qr2eat.it/',
	},
	files: {
		input_accepted: '.jpg, .jpeg, .png',
	},
	regex: {
		credential___username: /^[a-zA-Z0-9_]{3,32}$/,
		credential___email: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_.-]+\.[a-zA-Z_.-]{2,}$/i,
		credential___password: /^(.{6,32})$/,
		text___url: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
		text___hashtag: /^#\w+/,
		text___usertag: /^@\w+/,
		text___whitespace: / +/,
		types___objectId: /\b[a-f0-9]{24}\b/,
	},
}